import { render, staticRenderFns } from "./OperatoreMain.vue?vue&type=template&id=4cba99a9&"
import script from "./OperatoreMain.vue?vue&type=script&lang=js&"
export * from "./OperatoreMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports